<template>
  <b-modal v-model="isModalActive" :id="'sideBar' + $store.state.sidebar">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h3 v-if="!form.id">ADD NEW USER</h3>
        <h3 v-else>UPDATE USER</h3>
      </div>
      <div class="form-modal-body">
        <b-field label="First name">
          <b-input v-model="form.first_name"></b-input>
        </b-field>

        <b-field label="Last name">
          <b-input v-model="form.last_name"></b-input>
        </b-field>

        <b-field label="Profile Image">
          <div class="input-widget">
            <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
              location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
              :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.profile_image"
              @onFileSelected="onImageSelected">
              <div class="image-upload-widget">Choose Image to upload</div>
            </upload-trigger>
          </div>
        </b-field>
        <b-field label="Phone">
          <b-input v-model="form.phone_number"></b-input>
        </b-field>
        <b-field label="Email">
          <b-input v-model="form.email"></b-input>
        </b-field>
        <b-field label="Password">
          <b-input v-model="form.password"></b-input>
        </b-field>
        <b-field label="Account Type">
          <b-select v-model="form.account_type" expanded>
            <option value="wecodefystaff">Wecodefy Staff</option>
            <option value="streamer">Partner</option>
          </b-select>
        </b-field>
        <div class="input-group" v-if="form.account_type == 'streamer'">
          <div class="row">
            <b-field label="Subscription Fee" style="width: 100%">
              <b-numberinput v-model="form.subscription_fee" controls-alignment="right"
                controls-position="compact"></b-numberinput>
            </b-field>
            <div class="h-spacer"></div>
            <b-field label="Streaming Fee" style="width: 100%">
              <b-numberinput v-model="form.streaming_fee" controls-alignment="right"
                controls-position="compact"></b-numberinput>
            </b-field>
          </div>
          <div class="row">
            <b-field label="Voting Fee" style="width: 100%">
              <b-numberinput v-model="form.voting_fee" controls-alignment="right"
                controls-position="compact"></b-numberinput>
            </b-field>
            <div class="h-spacer"></div>
            <b-field label="E-Ticket Fee" style="width: 100%">
              <b-numberinput v-model="form.eticket_fee" controls-alignment="right"
                controls-position="compact"></b-numberinput>
            </b-field>
          </div>
          <div class="row">
            <b-field label="TopUp Voting Fee" style="width: 100%">
              <b-numberinput v-model="form.topupVotesFee" controls-alignment="right"
                controls-position="compact"></b-numberinput>
            </b-field>
            <div class="h-spacer"></div>
            <b-field label="Donation Fee" style="width: 100%">
              <b-numberinput v-model="form.donation_fee" controls-alignment="right"
                controls-position="compact"></b-numberinput>
            </b-field>
          </div>
          <div class="input-group" style="margin-top: 20px">
            <div class="row">
              <b-field label="Enable deposits" style="width: 30%">
                <b-switch v-model="form.enableDeposits" type="is-primary" rounded></b-switch>
              </b-field>
              <div v-if="form.enableDeposits" class="h-spacer"></div>
              <b-field v-if="form.enableDeposits" label="Deposits Phone Number(MTN)" style="width: 70%">
                <b-input v-model="form.depositsPhoneNumber" placeholder="Ex:078...,079..."></b-input>
              </b-field>
            </div>
          </div>
          <div class="input-group" style="margin-top: 10px">
            <div class="row">
              <b-field label="Domain" style="width: 100%">
                <b-input v-model="form.domain" placeholder="Ex: example.com"></b-input>
              </b-field>
              <div class="h-spacer"></div>
              <b-field label="Sub-Domain" style="width: 100%">
                <b-input v-model="form.subDomain" placeholder="Ex: sub.example.com"></b-input>
              </b-field>
            </div>
          </div>
          <div class="input-group" style="margin-top: 10px">
            <div class="row">
              <b-field label="Company name" style="width: 100%">
                <b-input v-model="form.companyName" placeholder="Ex: Example Ltd"></b-input>
              </b-field>
              <div class="h-spacer"></div>
              <b-field label="Company website" style="width: 100%">
                <b-input v-model="form.companyWebsite" placeholder="Ex: https://example.com"></b-input>
              </b-field>
            </div>
          </div>
          <div class="input-group" style="margin-top: 10px">
            <div class="row">
              <b-field label="Company location" style="width: 100%">
                <b-input v-model="form.companyLocation" placeholder="Ex: ,Kigali - Rwanda"></b-input>
              </b-field>
            </div>
          </div>
          <div class="input-group" v-if="form.domain">
            <label>Website Category</label>
            <div class="input-widget">
              <select type="text" v-model="form.website_category" class="bg-cagura-form-control">
                <option value="default">Default</option>
                <option value="streaming">Streaming</option>
                <option value="movies">Movies</option>
                <option value="events">Events</option>
                <option value="voting">Voting</option>
                <option value="voicesofhope">Voices of Hope</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="form-modal-footer">
        <b-button :loading="loading" @click="submitForm()" type="is-primary">SAVE</b-button>
        <div class="h-spacer"></div>
        <b-button @click="onCancel()" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    form: {
      id: null,
      first_name: "",
      last_name: "",
      profile_image: "",
      phone_number: "",
      email: "",
      password: "",
      account_type: "wecodefystaff",
      subscription_fee: 0,
      streaming_fee: 0,
      voting_fee: 0,
      topupVotesFee: 0,
      eticket_fee: 0,
      donation_fee: 0,
      domain: '',
      subDomain: '',
      website_category: 'default',
      enableDeposits: false,
      depositsPhoneNumber: '',
      companyName: '',
      companyWebsite: '',
      companyLocation: ''
    },
    loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.editItem(vm.value);
    } else {
      vm.addNew();
    }
  },
  methods: {
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
    editItem(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.first_name = item.first_name;
      vm.form.last_name = item.last_name;
      vm.form.profile_image = item.profile_image;
      vm.form.phone_number = item.phone;
      vm.form.email = item.email;
      vm.form.password = item.password_text;
      vm.form.account_type = item.account_type;
      vm.form.subscription_fee = item.subscription_fee;
      vm.form.streaming_fee = item.streaming_fee;
      vm.form.voting_fee = item.voting_fee;
      vm.form.topupVotesFee = item.topupVotesFee;
      vm.form.eticket_fee = item.ticketing_fee;
      vm.form.donation_fee = item.donation_fee;
      vm.form.domain = item.domain;
      vm.form.subDomain = item.subDomain;
      vm.form.website_category = item.domainCategory;
      vm.form.enableDeposits = item.enableDeposits == 1 ? true : false;
      vm.form.depositsPhoneNumber = item.depositPhoneNumber;
      vm.form.companyName = item.companyName;
      vm.form.companyWebsite = item.companyWebsite;
      vm.form.companyLocation = item.companyLocation;
    },
    addNew() {
      let vm = this;
      vm.form = {
        id: null,
        first_name: "",
        last_name: "",
        profile_image: "",
        phone_number: "",
        email: "",
        password: "",
        account_type: "wecodefystaff",
        subscription_fee: 0,
        streaming_fee: 0,
        voting_fee: 0,
        topupVotesFee: 0,
        eticket_fee: 0,
        donation_fee: 0,
        domain: '',
        subDomain: '',
        website_category: 'default',
        enableDeposits: false,
        depositsPhoneNumber: '',
        companyName: '',
        companyWebsite: '',
        companyLocation: ''
      };
    },
    submitForm() {
      let vm = this;
      vm.loading = true;
      if (!vm.form.id) {
        vm.$store
          .dispatch("ADMIN_USER_ADD_NEW", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.$emit("saved");
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      } else {
        vm.$store
          .dispatch("ADMIN_USER_UPDATE", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.$emit("saved");
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }
    },
    onImageSelected(file) {
      let vm = this;
      vm.form.profile_image = file;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

.modal {
  @media (max-width: 500px) {
    padding: 0 !important;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>